import React from 'react';

const Topbar = () => { 
  return (
    <div id="top-bar" className="top-bar" style={{marginTop:'70px', backgroundColor:'#000'}}>
      <div className="container">
        <div className="row">
          {/* Adresse */}
          <div className="col-lg-12 col-md-8">
            <ul className="top-info text-center text-md-left ">
              <li>
                <i className="fas fa-map-marker-alt text-muted"></i>
                <p className="info-text text-muted"> 40, Avenue Lusambo, Quatier Wenze, Commune de Kitambo, Kinshasa RDC</p>
              </li>
            </ul>
          </div>

          {/* Réseaux sociaux */}
       
        </div>
      </div>
    </div>
  );
};

export default Topbar;
